import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Button } from "devextreme-react";

import moment from "moment";

import DataGrid, { Column, Paging, Pager, RemoteOperations, MasterDetail, Export } from "devextreme-react/ui/data-grid";
import LoadingGif from "../../../../../images/animacion2[18].gif";
import { doGetDraft, doGetFinancialbenefits, setPrestacionesEmpresaFiltradas, setShowHideForm, setCleanDataDraft, doGetPrestacionEconomicaPDF, setMainFilterSelected } from "./actions";

import { formatDateForFilter } from "../../../../../helpers/dateFormat";
import { filterType, filterData } from "../../../../../helpers/filterHelper";
import TableFilter from "../../../../Shared/tableFilter.jsx";

import validaciones from "../../../../../helpers/validaciones";
import UserInfoColumn from "../../../../Shared/UserInfoColumn";

import SiniestroInfoColumn from "../../../../Shared/SiniestroInfoColumn";
import { doGetDocumentBySiniestro } from "../../../Documentos/actions";
import Documentos from "../../../Documentos/modalDocumentos";
import ModalDraft from "./modalDraft";


const TableDetails = React.memo((props) => (

  <div style={{ textAlign: "left" }}>
    <span style={{ fontSize: 14 }}>
      Periodos de pago
    </span>

    <DataGrid
      className="simpleHeader cursor-disabled"
      showBorders={false}
      showColumnLines={false}
      hoverStateEnabled={false}
      // renderAsync
      showRowLines={false}
      dataSource={props.source}
    >
      <Column
        dataField="FechaDesde"
        caption="Fecha desde"
        type="date"
        dataType="date"
        format="dd/MM/yyyy"
      />
      <Column
        dataField="FechaHasta"
        caption="Fecha hasta"
        dataType="date"
        format="dd/MM/yyyy"
      />
      <Column dataField="DiasPagados" caption="Días pagados" />
      <Column
        dataField="FechaPago"
        caption="Fecha de pago"
        dataType="date"
        format="dd/MM/yyyy"
      />

      <Column
        dataField="FormaPago"
        caption="Forma de pago"
        format="currency"
        alignment="right"
        dataType="number"
      />
      <Paging
        defaultPageSize={10}
      />
    </DataGrid>
  </div>
));

class TablePrestacionesEconomicas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filtersLoaded: false,
      doFilterFechaSiniestro: false,
      FechaSiniestro: null,
      mainFilterSelected: null,
    };
    this.tableRef = React.createRef();
  }

  componentDidMount = async () => {
    if (!this.state.filtersLoaded) {
      // From: 1 año hacia atras
      // to: año actual.
      const data = {
        from: formatDateForFilter(moment().subtract(1, "year")),
        to: formatDateForFilter(moment()),
      };
      this.getListaPrestaciones(data, true);
      this.setState({ filtersLoaded: true });
    }
  }
  shouldComponentUpdate = (nextProps) => {
    if (this.props.jsonData !== nextProps.jsonData || this.props.showHideForm !== nextProps.showHideForm) return false;
    return true;
  }
  componentDidUpdate = (prevProps) => {
    if (prevProps.sucursalId !== this.props.sucursalId) {
      // From: 1 año hacia atras
      // to: año actual.
      const data = {
        from: formatDateForFilter(moment().subtract(1, "year")),
        to: formatDateForFilter(moment()),
      };
      this.getListaPrestaciones(data, true);
    }
  }

  componentWillUnmount = () => {
    if (this.props.showHideForm) {
      this.props.dispatch(setShowHideForm(false));
      this.props.dispatch(setCleanDataDraft());
    }
  }

  onExporting = (e) => {
    e.component.beginUpdate();
    e.component.columnOption("RutTrabajador", "visible", true);
    e.component.columnOption("IdSiniestro", "visible", true);
  }
  onExported = (e) => {
    e.component.columnOption("RutTrabajador", "visible", false);
    e.component.columnOption("IdSiniestro", "visible", false);
    e.component.endUpdate();
  }

  getButton = (element, row) => {
    if (row.data.TipoSiniestro.toLowerCase() == "no ley") return;
    switch (row.data.EstadoDocumentacion.toLowerCase()) {
      case "borrador":
        ReactDOM.render(<Button
          text="Borrador"
          type="default"
          className="slimButton"
          onClick={() => this.handleDocument(row)}
        />, element);
        break;
      case "sin documentacion":
        ReactDOM.render(<Button
          text="Enviar"
          type="default"
          className="slimButton"
          onClick={() => this.handleDocument(row)}
        />, element);
        break;
      case "objetado":
          ReactDOM.render(<Button
            text="Editar"
            type="default"
            className="slimButton"
            onClick={() => this.handleDocument(row)}
          />, element);
        break;
      case "cert Fisico":
        ReactDOM.render("Certificado físico", element);
        break;
      case "revision achs":
        ReactDOM.render(<Button
          text="Ver"
          type="success"
          className="slimButton"
          onClick={() => this.handleDctos(row)}
        />, element);
        break;
      case "aceptado":
        ReactDOM.render(<Button
          text="Ver"
          type="success"
          className="slimButton"
          onClick={() => this.handleDctos(row)}
        />, element);
        break;
      default:
        // ReactDOM.render(<Button text="Reenviar" type="success" className="slimButton" />, element);
        break;
    }
  }

  getListaPrestaciones = (data, firstLoad) => {
    const filtros = {
      RutEmpresa: this.props.companyId,
      RutUsuario: this.props.userData.RUT,
      Pagina: 1,
      RegistrosPorPagina: 100000,
      FechaDesde: data.from,
      FechaHasta: data.to,

    };
    if (validaciones.emptyText(this.props.sucursalId)) {
      filtros.idSucursal = this.props.sucursalId;
    }
    this.props.dispatch(doGetFinancialbenefits(filtros, firstLoad));
  }

  handleFilterChange = (text, filters, selMainFilter = null) => {
    if (filters.length == 0) {
      const selectOption = {
        index: 6, Icon: "0", name: "Todas las prestaciones", column: "estadoDocumentacion", value: { text: "TODAS", value: "TODAS" }
      }
      this.props.dispatch(setMainFilterSelected(selectOption));
      const option = 'TODAS';
      this.optionMainFilterSelected(option);
    } else {
      this.props.dispatch(setMainFilterSelected(selMainFilter));
    }
    const currentFilters = [...filters];

    if (text) {
      currentFilters.push({ column: "RutTrabajador", value: { text, value: text }, type: filterType.search });
      currentFilters.push({ column: "NombreTrabajador", value: { text, value: text }, type: filterType.search });
      currentFilters.push({ column: "IdPrestacion", value: { text, value: text }, type: filterType.search });
      currentFilters.push({ column: "IdSiniestro", value: { text, value: text }, type: filterType.search });
    }

    const FechaSiniestro = currentFilters.length > 0 ? currentFilters.filter((f) => f.column === "FechaSiniestro") : [];
    if (FechaSiniestro.length > 0) {
      const pivotFecha = FechaSiniestro.find((i) => i.column === "FechaSiniestro");
      let FechaDesde = null;
      if (this.state.doFilterFechaSiniestro === true) {
        FechaDesde = this.state.FechaSiniestro;
      } else {
        FechaDesde = formatDateForFilter(moment().subtract(1, "year"));
      }
      const dateIsBefore = moment(pivotFecha.value.value.from).isBefore(moment(FechaDesde));
      // llamado al api cuando las fechas son menores con respecto a las que mando por primera vez
      if (dateIsBefore === true) {
        const data = {
          from: formatDateForFilter(moment(pivotFecha.value.value.from)),
          to: formatDateForFilter(moment(pivotFecha.value.value.to)),
        };
        this.getListaPrestaciones(data, false);
        this.setState({
          doFilterFechaSiniestro: true,
          FechaSiniestro: pivotFecha.value.value.from,
        });
      }
    }
    if (this.state.doFilterFechaSiniestro && FechaSiniestro.length === 0) {
      // vuelvo a la carga de datos inicial. al limpiar el rango de fecha que fue menor a la orginal
      const data = {
        from: formatDateForFilter(moment().subtract(1, "year")),
        to: formatDateForFilter(moment()),
      };
      this.getListaPrestaciones(data, true);
      this.setState({
        doFilterFechaSiniestro: false,
        FechaSiniestro: null,
      });
    }

    let newData = null;

    if (currentFilters.length > 0) {
      newData = filterData(this.props.listaPrestaciones, currentFilters);
    } else if (this.state.mainFilterSelected !== "TODAS") {
      const currentFiltersDefault = [
        {
          column: "EstadoDocumentacion", value: { text: "Sin Documentacion", value: "Sin Documentacion" },
        },
      ];
      newData = filterData(this.props.listaPrestaciones, currentFiltersDefault);
    } else {
      this.setState({mainFilterSelected: "TODAS"});
      newData = this.props.listaPrestaciones;
    }

    this.props.dispatch(setPrestacionesEmpresaFiltradas(newData));
  }
  optionMainFilterSelected = (option) => {
    this.setState({ mainFilterSelected: option });
  }
  handleDctos = (row) => {
    const { IdPrestacion } = row.data;
    const { NombreTrabajador } = row.data;
    const { RutTrabajador } = row.data;
    this.props.dispatch(doGetPrestacionEconomicaPDF(IdPrestacion, NombreTrabajador, RutTrabajador));
  }
  pivotDownloadExcel = () => {
    this.tableRef.exportToExcel(false);
  }
  downloadExcel = (options) => {
    if (options.gridCell.rowType === "data") {
      options.horizontalAlignment = "left";
    }
  }

  handleRowClick = (e) => {
    if (this.props.isLoading) return;

    if (e.data.PeriodoPagos == null || (e.data.PeriodoPagos != null && e.data.PeriodoPagos.length == 0)) {
      e.component.collapseRow(e.key);
      return;
    }

    if (e.data.EstadoDocumentacion === "Sin Documentacion" || e.data.EstadoDocumentacion === "Pendiente") {
      e.component.collapseRow(e.key)
      return;
    }

    if (e.handled) {
      if (e.isExpanded) {
        e.component.collapseAll(-1);
        e.component.expandRow(e.key);
      } else {
        e.component.collapseRow(e.key);
      }
    } else if (!e.isExpanded) {
      e.component.collapseAll(-1);
      e.component.expandRow(e.key);
    } else {
      e.component.collapseRow(e.key);
    }
  }
  handleDocument = (row) => {

    const UserName = row.data.NombreTrabajador.split(" ");
    const data = {
      idSiniestro: row.data.IdSiniestro,
      idFinancialBenefit: row.data.IdPrestacion == null ? row.data.IdSiniestro : row.data.IdPrestacion,
      userRut: this.props.userData.RUT,
      IsNew: row.data.IdPrestacion == null ? true : false,
      BpSucursal: row.data.BPSucursal,
      companyRut: this.props.companyId,
      employeeRut: row.data.RutTrabajador,
      jsonData: this.props.jsonData,
      fechaSiniestro: row.data.FechaSiniestro,
      fechaInicioUltimoReposo: row.data.FechaInicioUltimoReposo,
      FirstName: UserName[0],
      SecondName: UserName[1] ? UserName[1] : "",
      LastName: UserName[2],
      MotherName: UserName[3] ? UserName[3] : "",
      TipoPrestacion: row.data.TipoPrestacion,
      IdTipoPrestacion: row.data.IdTipoPrestacion,
      estadoObjetado: row.data.EstadoDocumentacion.toLowerCase() === 'objetado',
    };

    this.props.dispatch(doGetDraft(data));

  }
  handleToolbar = (e) => {
    const toolbarItems = e.toolbarOptions.items;
    const searchPanel = toolbarItems.find((item) => item.name === "searchPanel");
    searchPanel.location = "before";
  }

  render() {
    return (
      <React.Fragment>
        <ModalDraft />
        <TableFilter
          placeholder="Buscar trabajador por nombre o rut"
          onChange={this.handleFilterChange}
          filters={this.props.filtrosPrestaciones}
          show
          buttons={
            {
              filter: { buttonName: "iconFilter", visible: true, buttonAction: null },
              document: { buttonName: "iconDocument", visible: false, buttonAction: null },
              download: { buttonName: "iconDownload", visible: true, buttonAction: this.pivotDownloadExcel },
              newItem: { buttonName: "custom", visible: false, buttonAction: null },
            }
          }
          selectedMainFilter={this.props.selectedTipoPrestacion}
          mainFilter={this.props.mainFilters}
          optionMainFilterSelected={(option) => this.optionMainFilterSelected(option)}

        />
        <DataGrid
          dataSource={this.props.listaPrestacionesFiltrada}
          showBorders={false}
          showColumnLines={false}
          showRowLines={false}
          noDataText=""
          className="custom-table empresas"
          ref={(ref) => { if (ref !== null) this.tableRef = ref.instance; }}
          rowAlternationEnabled
          hoverStateEnabled
          onRowClick={this.handleRowClick}
          loadPanel={{
            enabled: true,
            showPane: true,
            showIndicator: true,
            indicatorSrc: LoadingGif,
            text: "Cargando...",
          }}
          onContentReady={(e) => {
            if (e.component.totalCount() === 0) {
              const config = {};
              config.addClass = "table-margin";
              const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
              const element = validaciones.noDataDOMElement(config, "Sin prestaciones");
              noDataSpan.appendChild(element);
            }
          }}
          selection={{
            mode: "single",
          }}
          onExporting={this.onExporting}
          onExported={this.onExported}
        >

          <MasterDetail
            enabled
            template={(element, row) => {
              ReactDOM.render(
                <TableDetails source={row.data.PeriodoPagos} />
                , element
              )
            }}
          // component={React.memo((props) => <TableDetails source={props.data.PeriodoPagos} />)}
          />

          <Column
            allowSearch
            caption="Trabajador"
            calculateDisplayValue={(data) => data.NombreTrabajador}
            dataField={["NombreTrabajador", "RutTrabajador"]}
            cellTemplate={(element, row) => (
              <React.Fragment >
                {
                  ReactDOM.render(<UserInfoColumn
                    nombre={row.data.NombreTrabajador}
                    rut={row.data.RutTrabajador}
                  />, element)
                }
              </React.Fragment>
            )}
          />
          <Column
            caption="Rut"
            dataField="RutTrabajador"
            visible={false}
          />
          <Column
            caption="Siniestro"
            calculateDisplayValue={(data) => data.TipoSiniestro}
            cellTemplate={(element, row) => (
              <React.Fragment >
                {
                  ReactDOM.render(<SiniestroInfoColumn
                    active={row.data.Reposo}
                    title={row.data.TipoSiniestro}
                    subtitle={Number(row.data.IdSiniestro).toString()}
                  />, element)
                }
              </React.Fragment>
            )}

          />
          <Column
            caption="Id Siniestro"
            dataField="IdSiniestro"
            visible={false}
          />
          <Column
            dataType="date"
            dataField="FechaSiniestro"
            calculateDisplayValue={(data) => data.FechaSiniestro ? moment(data.FechaSiniestro).format("DD/MM/YYYY") : "S/D"}
            format="dd/MM/yyyy"
            sortIndex={0}
            sortOrder="asc"
            sortingMethod={(v1, v2) => {
              const v1d = moment(v1, "DD/MM/YYYY");
              const v2d = moment(v2, "DD/MM/YYYY");
              if (v1d.isAfter(v2d)) return -1;
              if (v1d.isSame(v2d)) return 0;
              if (v1d.isBefore(v2d)) return 1;
              return 0;
            }}
          />

          <Column
            dataField="TipoPrestacion"
            caption="Prestación"
            calculateDisplayValue={(data) => data.TipoPrestacion}
            cellTemplate={(element, props) => (
              <React.Fragment >
                {
                  ReactDOM.render(
                    <div className="group-Column-Prestaciones">
                      <div
                        className={(props.data.TipoPrestacion === "SUBSIDIO DIRECTO" || props.data.TipoPrestacion === "NO" || props.data.TipoPrestacion === "null") ? "table-label-light-blue" :
                          props.data.TipoPrestacion === "Indemnizacion" ? "table-label-green" :
                            props.data.TipoPrestacion === "Pension" ? "table-label-gray" : null
                        }
                      >
                        {(props.data.TipoPrestacion === "NO" || props.data.TipoPrestacion === "null" ? "SUBSIDIO DIRECTO" : props.data.TipoPrestacion)}
                      </div>
                      <div className="text spaceText" >{Number(props.data.IdPrestacion).toString()}</div>
                    </div>
                    , element
                  )
                }
              </React.Fragment>
            )}
          />

          <Column
            dataField="EstadoDocumentacion"
            caption="Estado documentación"
            calculateDisplayValue={(data) => data.EstadoDocumentacion || "S/D"}
            cellTemplate={(element, props) => (
              <React.Fragment >
                {
                  ReactDOM.render(
                    <div>
                      {props.data.EstadoDocumentacion === "Objetado" && (
                        <div className="objetado"> <div className="iconoObjetado"><i className="material-icons">error_outline</i> </div> {props.data.EstadoDocumentacion}</div>
                      )}
                      {props.data.EstadoDocumentacion !== "Objetado" && (
                        <div> {props.data.EstadoDocumentacion}</div>
                      )}
                    </div>
                    , element
                  )
                }
              </React.Fragment>
            )}
          />

          <Column
            caption=""
            cellTemplate={(element, row) => (
              <React.Fragment >
                {this.getButton(element, row)}
              </React.Fragment>
            )}

          />

          <RemoteOperations
            paging={false}
            filtering
            summary={false}
            groupPaging={false}
            grouping={false}
            sorting={false}
          />

          <Paging
            defaultPageSize={20}
          />

          <Pager
            visible
            showInfo
            infoText={(page, total, items) => `Página ${page} de ${total} (${items} resultados)`}
          />
          <Export visible={false} enabled customizeExcelCell={this.downloadExcel} allowExportSelectedData={false} texts fileName="PrestacionesEmpresa" />
        </DataGrid>

        <Documentos />

      </React.Fragment>

    );
  }
}

const mapStateToProps = (state) => ({
  sucursalId: state.global.sucursalId,
  companyId: state.global.companyId,
  listaPrestaciones: state.prestacionesEmpresa.listaPrestaciones,
  listaPrestacionesFiltrada: state.prestacionesEmpresa.listaPrestacionesFiltrada,
  isDownloadLoading: state.prestacionesEmpresa.isDownloadLoading,
  filtrosPrestaciones: state.prestacionesEmpresa.filtrosPrestaciones,
  totalPrestaciones: state.prestacionesEmpresa.totalPrestaciones,
  isLoading: state.documentos.isLoading || state.prestacionesEmpresa.isLoading,
  jsonData: state.prestacionesEmpresa.jsonData,
  userData: state.global.userData,
  selectedTipoPrestacion: state.prestacionesEmpresa.selectedTipoPrestacion,
  mainFilters: state.prestacionesEmpresa.mainFilters,
  showNoData: state.prestacionesEmpresa.showNoData,
  showHideForm: state.prestacionesEmpresa.showHideForm,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TablePrestacionesEconomicas);
